import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { DEFAULT_RETRY_COUNT, DEFAULT_RETRY_INTERVAL } from '@assets/constants';

type ReactQueryErrorNotifier = (error: unknown) => void;

let reactQueryErrorNotifier: ReactQueryErrorNotifier | undefined;

/** Registers the notification bridge used by global React Query error handlers. */
export const setReactQueryErrorNotifier = (notifier?: ReactQueryErrorNotifier) => {
  reactQueryErrorNotifier = notifier;
};

/** Reports an unhandled query or mutation error without coupling the client to React hooks. */
const reportReactQueryError = (error: unknown) => {
  reactQueryErrorNotifier?.(error);
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      // Live queries with inline error states must not emit a toast on every poll.
      if (!query.meta?.errorHandledLocally) {
        reportReactQueryError(error);
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _onMutateResult, mutation) => {
      if (!mutation.options.onError) {
        reportReactQueryError(error);
      }
    },
  }),
  defaultOptions: {
    queries: {
      retry: DEFAULT_RETRY_COUNT,
      refetchInterval: DEFAULT_RETRY_INTERVAL,
    },
  },
});
